import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-da899744"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "major-name"
};
const _hoisted_2 = {
  class: "plan-detail"
};
const _hoisted_3 = {
  class: "org-info"
};
const _hoisted_4 = {
  class: "org-name"
};
import { Right, OfficeBuilding } from '@element-plus/icons-vue';
import { getUrlParams } from '@/plugins/utils';
export default /*#__PURE__*/_defineComponent({
  props: {
    trainingPlan: null
  },

  setup(__props) {
    const menuInfo = reactive({
      menuId: getUrlParams('menuId'),
      menuName: getUrlParams('name')
    });
    const source = getUrlParams('menuType'); // 详情

    const handlePlanDetail = id => {
      if (source === 'trainingPlan') {
        window.location.href = `/trainingSchemeDetail.html?source=${source}&id=${id}`;
      } else {
        window.location.href = `/trainingSchemeDetail.html?menuId=${menuInfo.menuId}&name=${menuInfo.menuName}&id=${id}`;
      }
    };

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("section", {
        class: "training-plan-card",
        onClick: _cache[0] || (_cache[0] = $event => handlePlanDetail(__props.trainingPlan.id))
      }, [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.trainingPlan.majorName), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(OfficeBuilding))]),
        _: 1
      }), _createElementVNode("span", _hoisted_4, _toDisplayString(__props.trainingPlan.organName), 1)]), _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Right))]),
        _: 1
      })])]);
    };
  }

});